'use strict';

angular.module('wamasysApp')
    .controller('HeaderController', function ($scope, $location,  $translate, $state, JhiLanguageService,Auth, ManualHelpContextService,Principal, ENV, NotificationInbox) {
        $scope.isAuthenticated = Principal.isAuthenticated;
        $scope.$state = $state;
        $scope.inProduction = ENV === 'prod';
        
        $scope.currentLanguage =  $translate.use();
    	
    
        var vm = this;
        vm.notifications = NotificationInbox.state;
        vm.refreshNotifications = NotificationInbox.refresh;
        $scope.$on('$stateChangeSuccess', function () { vm.notifications.toast = null; });
        vm.showteamwork = false;
        vm.searchContratHeader = '' ;
        vm.canSearchManualHelp = false;
        vm.canUseAssistant = false;
        vm.canSeeNewFeatures = false;
        vm.isSuperAdmin = false;

        vm.isAuthenticated = Principal.isAuthenticated;
        vm.username = "" ;
        vm.user = {} ;
        Principal.identity().then(function(account) {
        	if(account){
              updateUserContext(account);

        	}
        });

        $scope.$watch(function () {
            return Principal.getIdentityIfExist();
        }, function (account) {
            if (account) {
                updateUserContext(account);
            } else {
                vm.showteamwork = false;
            }
        });
        
        $scope.logout = function () {
            Auth.logout();
            $state.go('home');
        };
        
        vm.searchContrat = function(){
        	  $state.go('contrat', {searchQuery:vm.searchContratHeader},null);
        }

		vm.openAssistant = openAssistant;
		function openAssistant() {
            if (!vm.canSearchManualHelp) {
                return;
            }
		    ManualHelpContextService.openAssistant();
		}

        function hasAssistantAuthority(authorities) {
            var index;
            for (index = 0; index < authorities.length; index++) {
                if (authorities[index] === 'ROLE_AI_ASSISTANT'
                    || authorities[index] === 'ROLE_ADMIN'
                    || authorities[index] === 'ROLE_SUPER_ADMIN') {
                    return true;
                }
            }
            return false;
        }

        function hasManualHelpSearchAuthority(authorities) {
            var index;
            for (index = 0; index < authorities.length; index++) {
                if (authorities[index] === 'ROLE_DATA_OPERATOR'
                    || authorities[index] === 'ROLE_READ_ONLY'
                    || authorities[index] === 'ROLE_AREA_MANAGEMENT'
                    || authorities[index] === 'ROLE_COLLECTOR'
                    || authorities[index] === 'ROLE_AI_ASSISTANT'
                    || authorities[index] === 'ROLE_ADMIN'
                    || authorities[index] === 'ROLE_SUPER_ADMIN') {
                    return true;
                }
            }
            return false;
        }

        function updateUserContext(account) {
            var authorities = account.authorities || [];
            var modules = account.modules || [];

            vm.username = account.login;
            vm.user = account;
            vm.canSearchManualHelp = hasManualHelpSearchAuthority(authorities);
            vm.canUseAssistant = modules.indexOf('AI_ASSISTANT') !== -1
                && hasAssistantAuthority(authorities);
            vm.canSeeNewFeatures = modules.indexOf('NEW_FEATURES_VISIBILITY') !== -1;
            vm.isSuperAdmin = authorities.indexOf('ROLE_SUPER_ADMIN') !== -1;
            vm.showteamwork = modules.indexOf('TEAM') !== -1;
            ManualHelpContextService.setCapabilities(vm.canSearchManualHelp, vm.canUseAssistant);
        }

    })
    .directive('myEnter', function () {
	    return function (scope, element, attrs) {
	
	        element.on('keydown', function (event) {
	            if (event.which === 13) {
	
	                scope.$applyAsync(function () {
	                    scope.$eval(attrs.myEnter);
	                });
	
	                event.preventDefault();
	                event.stopPropagation();
	            }
	        });
	
	        scope.$on('$destroy', function () {
	            element.off('keydown');
	        });
	    };
    });

//    .directive('myEnter', function () {
//	    return function (scope, element, attrs) {
//	        element.bind("keydown keypress", function (event) {
//	            if(event.which === 13) {
//	                scope.$apply(function (){
//	                    scope.$eval(attrs.myEnter);
//	                });
//	
//	                event.preventDefault();
//	            }
//	        });
//	    };
//	});
    
